import { render, staticRenderFns } from "./GeneralReportsTable.vue?vue&type=template&id=4ccf0e5c&"
import script from "./GeneralReportsTable.vue?vue&type=script&lang=js&"
export * from "./GeneralReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports